import { transition } from "d3-transition";
import { select, selectAll } from "d3-selection";
import { scaleLinear, scaleBand } from "d3-scale";
import { min, max, ascending, groups } from "d3-array";
import { axisBottom } from "d3-axis";
export default {
  transition,
  select,
  selectAll,
  scaleLinear,
  scaleBand,
  min,
  max,
  ascending,
  groups,
  axisBottom,
};
